var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"logo-gov-co",attrs:{"src":require("@/assets/img/logo-gov-co.png"),"alt":"Gobierno de Colombia"}})}
var staticRenderFns = []

export { render, staticRenderFns }